<script setup lang="ts">
import QRCodeStyling from 'qr-code-styling'
import type { HTMLAttributes } from 'vue'

const props = defineProps<{
  class?: HTMLAttributes['class']
  imgWidth?: string
  imgHeight?: string
}>()

const { public: config } = useRuntimeConfig()
const { $utm } = useNuxtApp()

const qrContent = ref('/images/batch-2/qr-install.png')

const generateQr = () => {
  const generateQR = new QRCodeStyling({
    image: '/apple-touch-icon.png',
    width: 200,
    height: 200,
    data: $utm.utmUrl(config.url + '/link/app/1'),
    margin: 0,
    dotsOptions: {
      color: '#000000',
      type: 'rounded'
    },
    backgroundOptions: {
      color: 'transparent'
    }
  })
  generateQR.getRawData().then((data) => {
    const url = URL.createObjectURL(data as Blob)
    qrContent.value = url
  })
}

onMounted(() => {
  generateQr()
})
</script>

<template>
  <div :class="cn('rounded-lg', props.class)">
    <NuxtImg
      :width="props.imgWidth ?? '120px'"
      :height="props.imgHeight ?? '120px'"
      :src="qrContent"
      alt="qr code install"
    />
  </div>
</template>
